import React from "react";
import * as Components from "components";
import { useSelector } from "react-redux";

const Board = ({ rows, currentDay, numDaysView, offset, statsType }) => {
  const isFilteringGroup = useSelector((state) => state.boardFilter?.groupId);
  return (
    <div key={"board"} className="board not-select">
      <table key="board-table" className="board-table">
        <tbody>
          {isFilteringGroup && rows.length === 0 ? (
            <tr
              style={{
                height: "40px",
                width: 60 * numDaysView,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                paddingLeft: "10px",
                boxSizing: "border-box",
              }}
            >
              This group has no habits.
            </tr>
          ) : (
            rows.map((row, i) =>
              row.isHabit ? (
                <Components.HabitRow
                  key={"habit-row-" + row.id}
                  habit={row}
                  currentDay={currentDay}
                  numDaysView={numDaysView}
                  offset={offset}
                  count={i}
                />
              ) : (
                <Components.GroupRow
                  key={"group-row-" + row.id}
                  group={row}
                  currentDay={currentDay}
                  numDaysView={numDaysView}
                  offset={offset}
                  count={i}
                />
              )
            )
          )}
        </tbody>
      </table>
      <Components.Stats rows={rows} statsType={statsType} />
    </div>
  );
};

export default Board;
